export var ENVIRONMENT;
(function(ENVIRONMENT) {
    ENVIRONMENT["local"] = "local";
    ENVIRONMENT["dev"] = "dev";
    ENVIRONMENT["stg"] = "stg";
    ENVIRONMENT["production"] = "production";
    ENVIRONMENT["hipaa"] = "hipaa";
})(ENVIRONMENT || (ENVIRONMENT = {}));

//# sourceMappingURL=EnvironmentType.js.map